import { createContext } from 'react';
import { IEventsState, DispatchIEventsState } from './eventsContext.types';
export const EventsStateContext = createContext<Partial<IEventsState>>({});
export const EventsDispatchContext = createContext<DispatchIEventsState | undefined>(undefined);